// Regras de casamento título -> tipo de alerta, do lado do cliente.
//
// ESPELHO de link-sale-backend/src/scripts/automacaoAlertas/motorRegras.js
// (`casaTipo` / `atendeSeveridadeMinima`). Existe para o testador da tela de
// configuração responder na hora, sem round-trip: os dois lados são JavaScript
// e usam a mesma `RegExp` com flag "i", então o resultado é o mesmo. Ao mudar a
// semântica lá, mude aqui — o backend continua sendo a autoridade (é ele que
// filtra o painel e dispara automação).

import { SEVERIDADES } from "./labels";

export const SINAL_ADITIVO = "ADITIVO";
export const SINAL_SUBTRATIVO = "SUBTRATIVO";

export const LABEL_SINAL = {
	[SINAL_ADITIVO]: "Incluir",
	[SINAL_SUBTRATIVO]: "Excluir",
};

// Mesmo teto do backend (tiposAlerta.js) — barra antes de mandar.
export const TAMANHO_MAX_PADRAO = 200;

// SEVERIDADES vem de labels.js da mais grave para a menos grave; o rank do
// motor é o inverso (maior = pior).
const rankSeveridade = (severidade) => {
	const i = SEVERIDADES.indexOf(severidade);
	return i === -1 ? -1 : SEVERIDADES.length - 1 - i;
};

// Compila o padrão; null quando a regex é inválida.
export function compilarPadrao(padrao) {
	const texto = String(padrao || "").trim();
	if (!texto) return null;
	try {
		return new RegExp(texto, "i");
	} catch (erro) {
		return null;
	}
}

export function padraoInvalido(padrao) {
	return !!String(padrao || "").trim() && !compilarPadrao(padrao);
}

function normalizar(regras) {
	if (!Array.isArray(regras)) return [];
	return regras
		.filter((r) => r && String(r.padrao || "").trim())
		.map((r) => ({
			sinal: r.sinal === SINAL_SUBTRATIVO ? SINAL_SUBTRATIVO : SINAL_ADITIVO,
			padrao: String(r.padrao).trim(),
		}));
}

/**
 * Avalia um título contra as regras de um tipo e devolve o porquê, não só o
 * veredito — a tela mostra qual regra decidiu.
 *
 * @returns {{ casa: boolean, aditivasCasadas: string[], subtrativaVetou: string|null }}
 */
export function avaliarRegras(titulo, regras) {
	const lista = normalizar(regras);
	const nome = String(titulo || "");
	const casa = (r) => {
		const regex = compilarPadrao(r.padrao);
		return regex ? regex.test(nome) : false;
	};

	const aditivasCasadas = lista
		.filter((r) => r.sinal === SINAL_ADITIVO && casa(r))
		.map((r) => r.padrao);

	const subtrativa = lista.find((r) => r.sinal === SINAL_SUBTRATIVO && casa(r));

	return {
		casa: aditivasCasadas.length > 0 && !subtrativa,
		aditivasCasadas,
		subtrativaVetou: subtrativa ? subtrativa.padrao : null,
	};
}

export function casaTipo(titulo, regras) {
	return avaliarRegras(titulo, regras).casa;
}

// `alto` = alto ou pior. Sem piso, tudo passa.
export function atendeSeveridadeMinima(severidade, severidadeMinima) {
	if (!severidadeMinima) return true;
	const rankMin = rankSeveridade(severidadeMinima);
	if (rankMin === -1) return true;
	const rank = rankSeveridade(severidade);
	if (rank === -1) return false;
	return rank >= rankMin;
}
